import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199607b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-color-grid" }

import { ref } from 'vue';
import { useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from './transitions';
import ColorButton from './color-button.vue';
import chroma from 'chroma-js';
import { sample } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'grid-color-picker',
  props: {
    colors: null,
    eliminiation: { type: Boolean }
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const { colors = [], eliminiation = false } = __props as {
    colors: chroma.Color[],
    eliminiation?: boolean
}

_useCssVars(_ctx => ({
  "ab8dea3a": (_unref(btnWidth))
}))




let btnWidth = '';
let cols = 4;
if (colors.length <= 20) {
    cols = 4;
    btnWidth = '20%';
} else {
    cols = 5;
    btnWidth = '16%';
    if (colors.length % 5 !== 0){
        console.warn('<GridColorPicker />: Use multiples of 5 when there are more than 20 colors.');
    }
}

const handleColorSelected = async (color: chroma.Color, motionKey: string) => {
    if (eliminiation){
        let motion = useMotions()[motionKey];
        if (motion){
            motion.apply({
                opacity: 0,
                scale: 3,
                transition: {
                    duration: 225,
                    ease: 'easeIn',
                    /**
                     * Necessary or else the element will sometimes hover invisible over another
                     * element, preventing it from being clicked.
                     */
                    onComplete: () => {
                        (<HTMLElement> motion.target).style.pointerEvents = 'none';
                    }
                }
            })
        }
    }

    emit('select', color);
}

const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false && index === colors.length - 1){
        entered.value = true;
        emit('enter');
    }
}

const variations = <const> [
    {
        name: 'circles',
        style: {
            width: btnWidth,
            borderRadius: '100%'
        },
    },
    { //Tight grid, no spacing
        name: 'tight',
        style: {
            width: `${100 / cols}%`,
            borderRadius: '0%',
            flexGrow: 1,
            margin: 0,
            padding: 0
        }
    },
    { //Normal rounded btn grid
        name: 'rounded',
        style: {
            width: btnWidth,
        }
    }
]

/**
 * Given an index, returns a style object which rounds the corners of the buttons on 
 * the corners of the grid as defined by the `cols` variable. Used to round only the corner
 * blocks when the grid type is 'tight'.
 */
const getBorderRadiusStyle = (index: number) => {
    let style = {}, pos = index + 1;
    if (pos === 1) style = { ...style, borderTopLeftRadius: '4px' };
    if (pos === cols) style = { ...style, borderTopRightRadius: '4px' };
    if (pos === (colors.length - cols) + 1) style = { ...style, borderBottomLeftRadius: '4px' };
    if (pos === colors.length) style = { ...style, borderBottomRightRadius: '4px' };
    return style;
}

const btnStyle = sample(variations)!;
const getBtnStyle = (index: number) => {
    if (btnStyle.name === 'tight'){
        return { ...btnStyle.style, ...getBorderRadiusStyle(index) };
    }
    return btnStyle.style;
}

expose({
    leave: () => gameSetLeave(useMotions())
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colors, (color, i) => {
      return _withDirectives((_openBlock(), _createBlock(ColorButton, _mergeProps({
        color: color.hex(),
        class: "k-pick-color-btn",
        style: getBtnStyle(i),
        onClick: () => handleColorSelected(color, `btnMotion${i}`)
      }, _unref(getGameSetTransitions)(i, { onComplete: handleTransitionComplete })), null, 16, ["color", "style", "onClick"])), [
        [_directive_motion, `btnMotion${i}`]
      ])
    }), 256))
  ]))
}
}

})